"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSubsystem = void 0;
const generate_child_subsystems_1 = require("./generate-child-subsystems");
const utils_1 = require("../../utils");
const generateSubsystem = (contactRefId, subsystemName, subsystemOptions) => {
    const childSubsystems = (0, generate_child_subsystems_1.generateChildSubsystems)(contactRefId, subsystemName, subsystemOptions);
    const status = (0, utils_1.getMostSevereStatus)(childSubsystems);
    return {
        name: subsystemName,
        status: status,
        childSubsystems: childSubsystems,
    };
};
exports.generateSubsystem = generateSubsystem;
